let arr=[
    {name:'行业协会',value:'行业协会'},
    {name:'合作社',value:'合作社'},
    {name:'企业',value:'企业'}
]
export default arr